angular.module('licensure.internal')
    .directive('internalModuleAlerts', ['Alerts', '$rootScope', function (Alerts, $rootScope) {
        return {
            restrict: 'E',
            templateUrl: paths.app + 'components/alerts/alerts.html',
            scope: {
                alerts: '=?',
                entity: '@?',
                entityId: '=?',
                relatedEntity: '@?',
                relatedEntityId: '=?',
                isCoreRecord: '=?',
                filterAlerts: '=?'//Set to true if needed to filter out retired and retired on alerts
            },
            replace: true,
            link: function (scope, elem, attrs, ctrl) {
                scope.$watch('alerts', function () {
                    if (scope.alerts != null) {
                        var dupIDs = {};
                        scope.alerts.forEach(function (alert) {
                            alert.show = true;
                            if (alert.alert_type && alert.alert_type.days_to_retire != null) {
                                var now = new Date();
                                //the time the alert was created + the number of days until retirement (converted to ms) - the time it is now
                                //dividing by 1000 gives the time until retirement in seconds
                                var differenceInSecs = (alert.created_on.getTime() + (alert.alert_type.days_to_retire * 24 * 60 * 60 * 1000) - now.getTime()) / 1000;
                                if (differenceInSecs > 0) {
                                    alert.retire_days = Math.ceil(differenceInSecs / 86400);
                                }
                                else {
                                    //in case the alert_type.days_to_retire changes, we are just going to hide these on the front end and not actually retire them
                                    alert.show = false;
                                }
                            }

                            if (alert.show && alert.alert_type != null && !alert.alert_type.allow_duplicates) {
                                // Repeated alert, hide it.
                                if (dupIDs[alert.alert_type.id] && dupIDs[alert.alert_type.id].includes(alert.value)) {
                                    alert.show = false;
                                }
                                // First alert of it's value, add to dictionary
                                else if (dupIDs[alert.alert_type.id] && !dupIDs[alert.alert_type.id].includes(alert.value)) {
                                    dupIDs[alert.alert_type.id].push(alert.value);
                                }
                                // First Alert
                                else {
                                    dupIDs[alert.alert_type.id] = [alert.value];
                                }
                            }

                            if (scope.filterAlerts == true) {
                                if (alert.retired == true || (alert.retired_on != null && alert.retired_on.setHours(0, 0, 0, 0) < new Date().setHours(0, 0, 0, 0))) {
                                    alert.show = false;
                                }
                            }
                        });
                    }
                }, true)

                scope.getURL = function (alert, entityId, entity) {
                    var url = null;

                    if (entityId != null) {
                        if (entity == 'application') {
                            url = $rootScope.internalURL + 'license/applications/alerts/show.cfm?licenseRequestID=' + entityId + '&alertID=' + alert.id;
                        }
                        else if (entity == 'user') {
                            url = $rootScope.internalURL + 'license/users/alerts/show.cfm?userID=' + entityId + '&alertID=' + alert.id;
                        }
                        else if (entity == 'service') {
                            url = $rootScope.internalURL + 'license/services/alerts/show.cfm?serviceID=' + entityId + '&alertID=' + alert.id;
                        }
                        else if (entity == 'vehicle') {
                            url = $rootScope.internalURL + 'license/vehicles/alerts/show.cfm?vehicleID=' + entityId + '&alertID=' + alert.id;
                        }
                    }

                    return url;                    
                }
            }
        };
    }])
;